// import third party
import { isEmpty } from 'lodash';
import { Box, Button, Flex } from '@chakra-ui/react';

// import local
import { useConfirmModal } from '@store/useConfirmModal';
import useMutateUploadMapping from '@pages/UploadMappingV2/hooks/mutate/useMutateUploadMapping';
import TableListProduct from '@pages/UploadMappingV2/components/Table/TableListProduct';
import { useApp } from '@pages/UploadMappingV2/context/AppContext';
import { tableHeadListsProductSatuan } from './table/const';
import { usePieceStore } from '@pages/UploadMappingV2/hooks/state/useAddProductSatuan';
import ModalAddProductSatuan from '@pages/UploadMappingV2/components/ModalAddProductSatuan';
import ModalConfirmAddProductSatuan from '@pages/UploadMappingV2/components/ModalConfirmAddProductSatuan';

export default function ProductSatuan() {
    const { pieces, directPieces, isDirectEditing, resetDirectPieces, resetPiece, setIsAdding } = usePieceStore();
    const { set } = useConfirmModal();
    const { uploadProductSatuan, editProductSatuan } = useMutateUploadMapping();
    const {
        onOpenModalAddProductPiece,
        isOpenModalConfirmAddProductPiece,
        onOpenModalConfirmAddProductPiece,
        onCloseModalConfirmAddProductPiece,
    } = useApp();

    const handleSubmitMapping = () => {
        if (isEmpty(pieces)) {
            return set({
                isOpen: true,
                title: 'Belum ada product yang ditambahkan',
                desc: 'Tambahkan minimal 1 produk untuk menyimpan mapping.',
                btnLabelYes: 'Mengerti',
                isShowBtnNo: false,
            });
        }
        onOpenModalConfirmAddProductPiece();
    };

    const handleConfirmSave = () => {
        if (isDirectEditing) {
            const payload = directPieces.map(({ id, created_at, brand, localId, ...rest }) => ({
                ...rest,
            }))[0];

            editProductSatuan.mutate({ id: directPieces[0].id, payload: { piece: payload } });
        } else {
            const payload = pieces.map(({ id, ...rest }) => ({
                ...rest,
            }));
            uploadProductSatuan.mutate({ payload: { piece: payload, bundle: [] } });
        }
    };

    const handleCancelSave = () => {
        resetDirectPieces();
        onCloseModalConfirmAddProductPiece();
    };

    const handleAddPiece = () => {
        onOpenModalAddProductPiece();
        setIsAdding(true);
        resetDirectPieces();
        resetPiece();
    };

    return (
        <Box>
            <ModalAddProductSatuan />

            <ModalConfirmAddProductSatuan
                isOpen={isOpenModalConfirmAddProductPiece}
                onClose={handleCancelSave}
                onSubmit={handleConfirmSave}
            />

            <TableListProduct
                tableData={pieces}
                tableHeadLists={tableHeadListsProductSatuan}
                isDefaultExpanded
                isShowEmptyState={false}
                addItemLabel="Tambah Produk"
                onAddBtnClick={handleAddPiece}
            />
            <Flex justifyContent={'end'} mt={'24px'}>
                <Button px={'32px'} onClick={handleSubmitMapping}>
                    Simpan Mapping
                </Button>
            </Flex>
        </Box>
    );
}
